export function initTheme(): void {
  const root = document.documentElement;
  const saved = localStorage.getItem('nrg-theme');
  root.setAttribute('data-theme', saved === 'light' ? 'light' : 'dark');

  const toggle = document.getElementById('themeToggle');
  if (!toggle) return;

  toggle.addEventListener('click', () => {
    const current = root.getAttribute('data-theme');
    const next = current === 'light' ? 'dark' : 'light';

    root.classList.add('theming');
    root.setAttribute('data-theme', next);
    localStorage.setItem('nrg-theme', next);

    setTimeout(() => {
      root.classList.remove('theming');
    }, 620);
  });
}
